export const calculateExtraServicePrice = (rc_quotation, insurance_request_extra_service) => {
  let extraServicePrice = 0;

  if (rc_quotation.payment_frequency === 2) {
    if (insurance_request_extra_service.amount_paid === null && rc_quotation.amount_paid === null && rc_quotation.payments.length === 0) {
      extraServicePrice = insurance_request_extra_service.total_price / rc_quotation.payment_frequency;
    }

    if (insurance_request_extra_service.amount_paid === null && rc_quotation.amount_paid !== null && rc_quotation.payments.length !== 0) {
      extraServicePrice = insurance_request_extra_service.total_price;
    }

    if (insurance_request_extra_service.amount_paid !== null && rc_quotation.amount_paid !== null && rc_quotation.payments.length == 1) {
      extraServicePrice = insurance_request_extra_service.total_price / rc_quotation.payment_frequency;
    }
    if (insurance_request_extra_service.amount_paid !== null && rc_quotation.amount_paid !== null && rc_quotation.payments.length > 1) {
      extraServicePrice = insurance_request_extra_service.total_price;
    }
  } else {
    extraServicePrice = insurance_request_extra_service.total_price;
  }

  return parseFloat(extraServicePrice).toFixed(2);
};
